import React, { useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { SITE } from "../lib/constants";

const StickyMobileCTA = () => {
  const { lang } = useLanguage();

  useEffect(() => {
    // add padding-bottom to body so content doesn't get hidden behind CTA
    document.body.style.paddingBottom = "64px";
    return () => {
      document.body.style.paddingBottom = "";
    };
  }, []);

  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed inset-x-0 bottom-0 z-40 bg-[#0A192F] border-t border-white/10 shadow-[0_-8px_30px_rgba(0,0,0,0.25)]"
    >
      <div className="grid grid-cols-2 divide-x divide-white/10">
        <a
          href={SITE.phoneHref}
          data-testid="sticky-cta-call"
          className="flex items-center justify-center gap-2 py-3.5 text-sm font-bold uppercase tracking-[0.1em] text-white hover:bg-white/5 active:bg-white/10 transition"
        >
          <i className="fa-solid fa-phone text-[#FF5A1F]" aria-hidden="true"></i>
          {lang === "fr" ? "Appeler" : "Call"}
        </a>
        <a
          href={SITE.doctolibUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="sticky-cta-rdv"
          className="flex items-center justify-center gap-2 py-3.5 text-sm font-bold uppercase tracking-[0.1em] bg-[#FF5A1F] text-white hover:bg-[#e64a10] active:bg-[#cc3f0e] transition"
        >
          <i className="fa-solid fa-calendar-check" aria-hidden="true"></i>
          {lang === "fr" ? "Prendre RDV" : "Book"}
        </a>
      </div>
    </div>
  );
};

export default StickyMobileCTA;
